<template>
  <b-card>
    <b-overlay
      :show="loading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-form
        @submit.prevent
        @submit="changeProfileUpdateStatus"
      >
        <b-row>
          <b-card>
            <b-form-radio-group
              v-model="groupStatus"
              :options="radioOptions"
              class="demo-inline-spacing"
              value-field="value"
              text-field="text"
              disabled-field="disabled"
              :disabled="!canEditApprovalSetting"
              @change="changeProfileUpdateStatus"
            />
          </b-card>
        </b-row>
        <b-row>
          <div class="ml-2">
            When this setting is enabled, the admin can manage and approve any merchant profile updates submitted by merchants.
          </div>
        </b-row>
      </b-form>
      <b-row
        v-if="groupStatus"
        class="d-flex justify-content-end mt-3"
      >
        <div
          class="m-2"
        >
          <b-row class="d-sm-flex align-items-start">
            <b-col
              class="d-flex justify-content-end align-items-center mb-1 mb-md-0"
            >
              <ReportTableButtons
                :items="items"
                :json_fieldz="json_fields"
                :name="`Approval-Request-Types - Page ${page}.xls`"
                :bulkname="`Approval-Request-Types.xls`"
                :fetch="fetchDataForApprovalRequestTypesNoPagination"
                @refresh="onClickRefresh"
              />
            </b-col>
          </b-row>
        </div>
        <b-col cols="12">
          <b-table
            striped
            hover
            responsive
            show-empty
            :per-page="perPage"
            :items="items"
            :fields="fields"
          >
            <template #empty>
              <TableDataFetching
                :rows="items"
                :data-loading="dataLoading"
              />
            </template>
            <template #cell(type)="data">
              <div class="d-flex align-items-start">
                {{ data.value }}
              </div>
            </template>
            <template #cell(status)="data">
              <div v-if="data.value">
                <b-badge variant="light-success">
                  Active
                </b-badge>
              </div>
              <div v-if="!data.value">
                <b-badge variant="light-danger">
                  Inactive
                </b-badge>
              </div>
            </template>
            <template #cell(Action)="data">
              <b-dropdown
                v-can="'edit-profile-update-approval'"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="10"
                    class="text-body align-middle "
                  />
                </template>
                <b-dropdown-item
                  v-if="data.item.status === 1"
                  @click="statusAction(data.item.id , 0)"
                >
                  <feather-icon icon="ToolIcon" />
                  Inactive
                </b-dropdown-item>
                <b-dropdown-item
                  v-else
                  @click="statusAction(data.item.id , 1)"
                >
                  <feather-icon icon="ToolIcon" />
                  Active
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row
              cols="12"
            >
              <b-col
                class="d-flex align-items-center justify-content-sm-start"
                md="3"
              >
                <label class="width-75">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block"
                />
              </b-col>
              <b-col
                md="9"
                class="d-flex align-items-center justify-content-end"
              >
                <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                <b-pagination
                  v-model="page"
                  :per-page="perPage"
                  :total-rows="(meta.total)? meta.total : 0"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BFormRadioGroup,
  BCard,
  BForm,
  BOverlay,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const ApprovalSettingsRepository = RepositoryFactory.get('approvalSettings')

export default {
  components: {
    BTable,
    BRow,
    BCol,
    BFormRadioGroup,
    BCard,
    BForm,
    BOverlay,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      loading: false,
      dataLoading: false,
      fields: [
        {
          key: 'type', label: 'Setting Type', sortable: false, thClass: ' text-left', tdClass: ' text-left',
        },
        {
          key: 'status', label: 'Is Active', sortable: false, thClass: ' text-left', tdClass: ' text-left',
        },
        {
          key: 'Action', label: 'Action', sortable: false, thClass: ' text-left', tdClass: ' text-left',
        },
      ],
      form: {
        approvalGroup: 0,
      },
      radioOptions: [
        { text: 'On', value: 1 },
        { text: 'Off', value: 0 },
      ],
      items: [],
      groupStatus: false,
      json_fields: {
        'Setting Type': 'type',
        'Is Active': {
          field: 'status',
          callback: value => `"${value === 1 ? 'Active' : 'Inactive'}"`,
        },
      },
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
    }
  },
  computed: {
    canEditApprovalSetting() {
      return this.$can('edit-profile-update-approval')
    },
  },
  watch: {
    page() {
      this.fetchProfileUpdateSetting()
    },
    perPage() {
      this.fetchProfileUpdateSetting()
    },
  },
  mounted() {
    this.fetchProfileUpdateSetting()
    this.getGroupStatus()
  },
  methods: {
    async setProfileUpdateSetting() {
      this.loading = true
      try {
        const payload = {
          group_id: 2,
          status: this.groupStatus,
        }
        const response = await ApprovalSettingsRepository.changeProfileUpdateStatus(payload)
        if (response.status === 200) {
          this.showSuccessMessage(response.data.message)
          this.groupStatus = response.data.data.status
        } else {
          this.showErrorMessage(response.data.message)
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async fetchProfileUpdateSetting() {
      this.dataLoading = true
      this.items = []
      try {
        const groupId = 2
        const response = await ApprovalSettingsRepository.getProfileUpdateSettingTypes(groupId, this.page, this.perPage)
        this.items = response.data.data
        this.meta = response.data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async statusAction(id, status) {
      this.loading = true
      try {
        const payload = {
          type_id: id,
          status,
        }
        const response = await ApprovalSettingsRepository.statusAction(payload)
        if (response.status === 200) {
          this.showSuccessMessage(response.data.message)
          this.fetchProfileUpdateSetting()
        } else {
          this.showErrorMessage(response.data.message)
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },

    async getGroupStatus() {
      this.loading = true
      try {
        const groupId = 2
        const response = await ApprovalSettingsRepository.getGroupStatus(groupId)
        this.groupStatus = response.data.data.status
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    onClickRefresh() {
      this.fetchProfileUpdateSetting()
    },
    async fetchDataForApprovalRequestTypesNoPagination() {
      const groupId = 2
      const { data } = await ApprovalSettingsRepository.fetchDataForApprovalRequestTypesNoPagination(groupId)
      return data.data
    },
    handleChangePage(page) {
      this.page = page
      this.fetchProfileUpdateSetting()
    },
    changePage(value) {
      this.perPage = value
    },
    async changeProfileUpdateStatus() {
      await this.setProfileUpdateSetting()
    },
  },
}
</script>
<style scoped>
.per-page-selector {
    width: 125px;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .per-page-selector {
    width: 200px; /* Shrinks in tablet view */
  }
}
</style>
